import { apiAxiosCMS } from 'services/api';
import { BannersCarroselProps } from 'types/BannersCarroselProps';

interface RespReqProps {
	isSuccess: boolean;
	list: BannersCarroselProps[];
}

export async function getBanners(
	setIsOpenLoad: React.Dispatch<React.SetStateAction<boolean>>,
	handleNotify: any
) {
	const respReq: RespReqProps = {
		isSuccess: false,
		list: []
	};

	setIsOpenLoad(true);
	await apiAxiosCMS
		.get('banner')
		.then((res) => {
			respReq.isSuccess = true;
			respReq.list = res?.data || [];
		})
		.catch((error) => {
			console.error('✌️error --->', error);
			respReq.isSuccess = false;
			respReq.list = [];
			handleNotify('Erro ao buscar a lista de banners.', 'error');
		});

	setIsOpenLoad(false);
	return respReq;
}

export async function deleteBannerReq(id: string, handleNotify: any) {
	const respReq = {
		isSuccess: false
	};
	await apiAxiosCMS
		.delete(`banner/${id}`)
		.then(() => {
			handleNotify('Banner deletado com sucesso', 'success');
			respReq.isSuccess = true;
		})
		.catch((error) => {
			console.error('✌️error --->', error);
			handleNotify('Erro ao deletar banner, tente novamente.', 'error');
			respReq.isSuccess = false;
		});

	return respReq;
}
